import FacebookPixel from './scripts/facebookPixel';
import Gtag from './scripts/gtag';
import CohereScript from './scripts/cohere';
import ItercomScript from './scripts/intercom';
import OmnisendScript from './scripts/omnisend';
import LogDNA from './scripts/logdna';
import Canny from './scripts/canny';

let timeout;

const tracker = {
  /**
   * /pages/_app.js
   */
  onAppInit: () => {
    // Unconmment to log data
    // console.log('TRACKER', 'onAppInit');

    LogDNA.init();
  },

  /**
   * /pages/_app.js
   */
  pageView: route => {
    setTimeout(() => {
      const pageLocation = window.location.href;
      const pagePath = window.location.pathname;
      const pageTitle = window.document.title;

      // Unconmment to log data
      // console.log('TRACKER', 'pageView', { route, pageLocation, pagePath, pageTitle });

      FacebookPixel.pageView();
      Gtag.pageView(pageLocation, pagePath, pageTitle);
      OmnisendScript.pageView();
    }, 200);
  },

  productView: skuProduct => {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      FacebookPixel.productView(skuProduct.id, skuProduct.name, skuProduct.price, skuProduct.currency)
    }, 200);
  },

  /**
   * /pages/_app.js
   */
  cartItemAdd: skuProduct => {
    // Unconmment to log data
    // console.log('TRACKER', 'cartItemAdd', skuProduct);

    FacebookPixel.cartItemAdd(skuProduct.id, skuProduct.name, skuProduct.price, skuProduct.currency);
  },

  /**
   * /pages/cart/index.js
   */
  checkoutInit: (price, currency, promoCode, items) => {
    // Unconmment to log data
    // console.log('TRACKER', 'checkoutInit');

    FacebookPixel.checkoutInit(price, currency, items);
    Gtag.customEvent('checkout_init');
  },

  /**
   * /pages/cart/index.js
   */
  checkoutAmazonInit: () => {
    // Unconmment to log data
    // console.log('TRACKER', 'checkoutAmazonInit');

    Gtag.customEvent('checkout_init');
  },

  /**
   * /pages/cart/checkout.js
   */
  orderPaymentAdd: (type, price, currency, promoCode) => {
    // Unconmment to log data
    // console.log('TRACKER', 'orderPaymentAdd', { type, price, currency, promoCode });

    // FacebookPixel.orderPaymentAdd();
    Gtag.customEvent('checkout_payment');
  },

  /**
   * /pages/cart/checkout.js
   */
  orderPaymentFailure: (type, price, currency, message) => {
    // Unconmment to log data
    // console.log('TRACKER', 'orderPaymentAdd', { type, price, currency, message });

    Gtag.customEvent('checkout_payment_failure');
  },

  /**
   * /pages/cart/_confirmation.js
   */
  orderSend: orderData => {
    // Unconmment to log data
    // console.log('TRACKER', 'orderSend', orderData);

    const { externalOrderId, orderedItems } = orderData;
    // TODO map data in API call
    const {
      shipping_type: shippingType,
      payment_info: paymentInfo,
      shipping_address: shippingAddress,
    } = orderData.meta_data;
    const { items, overall: price, currency, applied_promo_code: promoCode, shipping } = paymentInfo;

    FacebookPixel.orderSend(price, currency, externalOrderId, items);
    Gtag.orderSend(price, currency, externalOrderId, shipping, orderedItems, promoCode);
  },

  /**
   * /pages/_app.js
   */
  userSet: (user = {}) => {
    // Unconmment to log data
    // console.log('TRACKER', 'userSet', user);
    CohereScript.init();
    CohereScript.identify(user.id, user.email, user.name);
    ItercomScript.identify(user.id, user.email, user.name);
    Canny.identify(user.id, user.email, user.name);
  },

  /**
   * /pages/cart/index.js
   * /pages/cart/amazon.js
   * /pages/cart/checkout.js
   */
  cartSet: (items, price, currency, email = '') => {
    // Unconmment to log data
    // console.log('TRACKER', 'cartSet', { items, price, currency, email });
  },

  /**
   * /pages/product/[productId].js
   */
  editorInit: sku => {
    // Unconmment to log data
    // console.log('TRACKER', 'editorInit', sku);
  },

  /**
   * /pages/_app.js
   */
  editorChoosePhotos: maximumNumberOfPhotos => {
    // Unconmment to log data
    // console.log('TRACKER', 'editorChoosePhotos', maximumNumberOfPhotos);
  },

  /**
   * /pages/_app.js
   */
  editorUploadPhotos: numberOfPhotos => {
    // Unconmment to log data
    // console.log('TRACKER', 'editorUploadPhotos', numberOfPhotos);
  },

  /**
   * /pages/_app.js
   */
  editorPreviewPrints: () => {
    // Unconmment to log data
    // console.log('TRACKER', 'editorPreviewPrints');
  },

  /**
   * /pages/editor/[...params].js
   */
  editorPreviewDone: (skuProduct, data) => {
    // Unconmment to log data
    // console.log('TRACKER', 'editorPreviewDone', { skuProduct, data });
  },

  /**
   * /pages/_app.js
   */
  editorUpgradeProduct: skuProduct => {
    // Unconmment to log data
    // console.log('TRACKER', 'editorUpgradeProduct', skuProduct);
  },

  /**
   * /pages/signin.js
   */
  signIn: userData => {
    // Unconmment to log data
    // console.log('TRACKER', 'signIn', userData);
    Gtag.customEvent('signin_email_success');
  },

  /**
   * /pages/signin.js
   */
  signUp: userData => {
    // Unconmment to log data
    // console.log('TRACKER', 'signUp', userData);
    Gtag.customEvent('signup_email_success');
  },

  /**
   * /pages/signin.js
   */
  signInWithAmazon: userData => {
    // Unconmment to log data
    // console.log('TRACKER', 'signInWithAmazon', userData);
    Gtag.customEvent('signin_amazon_success');
  },

  /**
   * /pages/signin.js
   */
  signInWithFacebook: userData => {
    // Unconmment to log data
    // console.log('TRACKER', 'signInWithFacebook', userData);
    Gtag.customEvent('signin_facebook_success');
  },

  /**
   * /pages/_app.js
   */
  onCustomEvent: (action, payload = {}) => {
    // Unconmment to log data
    // console.log('TRACKER', 'onCustomEvent', action, payload);

    Gtag.customEvent(action);
  },
};

export default tracker;
